module.exports = __webpack_public_path__ + "static/assets/e9b82f49559c7a78e7e57bd07b3edd45.png";